import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { PlainButton } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { ReactComponent as ReorderIcon } from "./assets/reorder.svg";

export interface DraggableFieldBoxContainerProps {
  id: string;
  index: number;
  children: ReactNode;
  isDragDisabled?: boolean;
  className?: string;
}

export const DraggableFieldBoxContainer: FC<
  DraggableFieldBoxContainerProps
> = ({ id, index, children, isDragDisabled, className }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: isDragDisabled,
    data: { index },
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        opacity: isDragging ? 0 : undefined,
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      className={cx("relative", className)}
    >
      {!isDragDisabled && (
        <PlainButton
          ref={setActivatorNodeRef}
          className="absolute top-1/2 -left-0.5 -translate-x-full -translate-y-1/2 cursor-grab active:cursor-grabbing"
          onClick={(event) => event.stopPropagation()}
          {...attributes}
          {...listeners}
        >
          <ReorderIcon />
        </PlainButton>
      )}
      {children}
    </div>
  );
};
